import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PageLoader } from '@/components/QueryState';
import { useAuth } from './context';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <PageLoader label="Signing you in…" />;
  if (status === 'signedOut') {
    const next = location.pathname + location.search;
    return (
      <Navigate
        to={`/login${next && next !== '/' ? `?next=${encodeURIComponent(next)}` : ''}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
